const MOBILE_BREAKPOINT = 821;
const SMALL_MOBILE_BREAKPOINT = 414;

const mobileBreakpoint = () => MOBILE_BREAKPOINT;
const smallMobileBreakpoint = () => SMALL_MOBILE_BREAKPOINT;

// Mobile device (with screen width < 821px). This prevents Chrome/Safari responsive modes being flagged as a mobile device.
const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  ) && window.innerWidth < MOBILE_BREAKPOINT;

// Desktop if screen width < 821px. This is used by picture component, showing always mobile image and not video, even on desktop when resized
const isSmallDevice = () => window.innerWidth < MOBILE_BREAKPOINT;

const isSmallMobile = () => window.innerWidth < SMALL_MOBILE_BREAKPOINT;

export {
  mobileBreakpoint,
  smallMobileBreakpoint,
  isMobile,
  isSmallMobile,
  isSmallDevice
};
